import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";

export default function LoginPage() {
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [showPwd,    setShowPwd]    = useState(false);
  const [error,      setError]      = useState("");
  const [loading,    setLoading]    = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const result = await login({ email, password });

      if (result.requiresMfa) {
        // MFA requis → rediriger vers la page de saisie du code
        // On passe rememberMe pour que la page MFA génère le bon token
        navigate("/verify-mfa", { state: { maskedEmail: result.maskedEmail, rememberMe } });
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:"100vh", display:"flex", background:"#F4F5F7" }}>

      {/* ── Panel gauche — branding CPUc ── */}
      <div className="login-brand" style={{
        width:"45%", background:"#1A1A1A",
        display:"flex", flexDirection:"column",
        justifyContent:"center", alignItems:"center",
        padding:"48px", position:"relative", overflow:"hidden",
      }}>
        <div style={{ position:"absolute", top:-120, right:-120, width:380, height:380, borderRadius:"50%", background:"#E63329", opacity:.08 }}/>
        <div style={{ position:"absolute", bottom:-80, left:-80, width:280, height:280, borderRadius:"50%", background:"#E63329", opacity:.05 }}/>

        <div style={{ position:"relative", textAlign:"center", maxWidth:360 }}>
          <img src="/logo-cpuc.png" alt="CPUc Solutions Technologiques"
            style={{ height:64, objectFit:"contain", marginBottom:32, filter:"brightness(0) invert(1)" }}
          />
          <div style={{ display:"inline-block", background:"rgba(230,51,41,.2)", border:"1px solid rgba(230,51,41,.4)", borderRadius:20, padding:"4px 14px", fontSize:12, color:"#E63329", fontWeight:600, marginBottom:20 }}>
            Console administrateur
          </div>
          <p style={{ color:"rgba(255,255,255,.55)", fontSize:13, lineHeight:1.8, marginBottom:32 }}>
            Gérez les entreprises clientes, les utilisateurs, les tickets et synchronisez les données depuis Atera.
          </p>
          <div style={{ display:"flex", flexDirection:"column", gap:12, textAlign:"left" }}>
            {[
              ["bi-building",             "Gestion de toutes les entreprises",        "#E63329", "rgba(230,51,41,.25)"],
              ["bi-people-fill",          "Administration des utilisateurs et rôles", "#A78BFA", "rgba(167,139,250,.25)"],
              ["bi-ticket-detailed-fill", "Supervision des tickets multi-clients",    "#34D399", "rgba(52,211,153,.25)"],
              ["bi-shield-lock-fill",     "Connexion protégée par double facteur",    "#fff",     "rgba(14,165,233,.7)"],
            ].map(([icon, text, color, bg]) => (
              <div key={text} style={{ display:"flex", alignItems:"center", gap:12 }}>
                <div style={{ width:34, height:34, borderRadius:10, background:bg, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                  <i className={`bi ${icon}`} style={{ fontSize:16, color:"#fff", WebkitTextFillColor:"#fff" }}/>
                </div>
                <span style={{ color:"rgba(255,255,255,.75)", fontSize:13 }}>{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Panel droit — formulaire ── */}
      <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", padding:24, background:"#fff" }}>
        <div style={{ width:"100%", maxWidth:400 }} className="anim-fade-up">

          <img src="/logo-cpuc.png" alt="CPUc"
            style={{ height:40, objectFit:"contain", marginBottom:28, display:"block" }}
            className="login-mobile-logo"
          />

          <h2 style={{ fontFamily:"Syne,sans-serif", fontSize:26, fontWeight:800, color:"#1A1A1A", marginBottom:4 }}>
            Connexion
          </h2>
          <p style={{ color:"#4B5563", fontSize:13, marginBottom:8 }}>
            Console d'administration CPUc
          </p>

          <div style={{ display:"flex", alignItems:"center", gap:8, background:"rgba(230,51,41,.06)", border:"1px solid rgba(230,51,41,.15)", borderRadius:8, padding:"8px 12px", marginBottom:24, fontSize:12, color:"#E63329" }}>
            <i className="bi bi-shield-lock-fill"/>
            Accès réservé aux administrateurs autorisés
          </div>

          {error && (
            <div style={{ background:"rgba(220,38,38,.08)", border:"1px solid rgba(220,38,38,.2)", borderRadius:10, padding:"10px 14px", marginBottom:20, fontSize:13, color:"#DC2626", display:"flex", alignItems:"center", gap:8 }}>
              <i className="bi bi-exclamation-triangle-fill"/>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="itm-label">Adresse email</label>
              <div className="input-group-itm">
                <i className="bi bi-envelope input-icon"/>
                <input type="email" className="itm-input"
                  value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="admin@cpucsolutions.com" required autoComplete="email"
                />
              </div>
            </div>

            <div className="form-group" style={{ marginBottom:8 }}>
              <label className="itm-label">Mot de passe</label>
              <div className="input-group-itm" style={{ position:"relative" }}>
                <i className="bi bi-lock input-icon"/>
                <input type={showPwd ? "text" : "password"} className="itm-input"
                  value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="••••••••" required style={{ paddingRight:42 }}
                  autoComplete="current-password"
                />
                <button type="button" onClick={() => setShowPwd(v => !v)}
                  style={{ position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", color:"#9CA3AF", fontSize:15 }}>
                  <i className={`bi bi-eye${showPwd ? "-slash" : ""}`}/>
                </button>
              </div>
            </div>

            <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:16 }}>
              <span style={{ fontSize:12, color:"#E63329", cursor:"pointer", fontWeight:500 }}
                onClick={() => navigate("/forgot-password")}>
                Mot de passe oublié ?
              </span>
            </div>

            {/* Badge sécurité MFA */}
            <div style={{ display:"flex", alignItems:"center", gap:8, padding:"8px 12px", background:"rgba(14,165,233,.06)", border:"1px solid rgba(14,165,233,.15)", borderRadius:8, marginBottom:16 }}>
              <i className="bi bi-shield-check-fill" style={{ color:"#0EA5E9", fontSize:14 }} />
              <span style={{ fontSize:12, color:"#0369A1" }}>
                Un code de vérification sera envoyé à votre email
              </span>
            </div>

            {/* Se souvenir de moi */}
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:20 }}>
              <input
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={e => setRememberMe(e.target.checked)}
                style={{ width:16, height:16, cursor:"pointer", accentColor:"#E63329" }}
              />
              <label htmlFor="rememberMe" style={{ fontSize:13, color:"#6B7280", cursor:"pointer", userSelect:"none" }}>
                Se souvenir de moi <span style={{ fontSize:11, color:"#9CA3AF" }}>(30 jours)</span>
              </label>
            </div>

            <button type="submit" className="btn-itm btn-itm-primary"
              style={{ width:"100%", justifyContent:"center", padding:"11px 16px", fontSize:14 }}
              disabled={loading}>
              {loading
                ? <><i className="bi bi-arrow-repeat spin"/> Connexion…</>
                : <><i className="bi bi-box-arrow-in-right"/> Se connecter</>
              }
            </button>
          </form>

          <p style={{ marginTop:24, fontSize:11, color:"#9CA3AF", textAlign:"center" }}>
            © {new Date().getFullYear()} CPUc Solutions Technologiques
          </p>
        </div>
      </div>

      <style>{`
        @media(max-width:768px){ .login-brand{display:none!important} .login-mobile-logo{display:block!important} }
        @media(min-width:769px){ .login-mobile-logo{display:none!important} }
      `}</style>
    </div>
  );
}